import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import PaidIcon from "@mui/icons-material/Paid";
import BuildIcon from "@mui/icons-material/Build";
import colors from "../../theme/colors";
import Item from "../Shared/Style/StyledItem";

export default function Cadastros() {
  const navigate = useNavigate();

  const NavigateTo = (path: string) => {
    navigate(path);
  };
  
  return (
    <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2 }, minHeight: { xs: "auto", md: "90vh" }, display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: { xs: 1, sm: 2 }, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Grid container spacing={2}>
          {/* Linha 1 - Cabeçalho e Descrição*/}
          <Grid item xs={12}> 
            <Paper sx={{ p: 1, bgcolor: '#f8f9fa' }}>
              <h4 style={{ margin: '0 0 0 0', color: colors.bluePrimary, textAlign: 'left' }}>
                ⚙️ Cadastros
              </h4>
              <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                Configurações e parâmetros do sistema
              </Typography>
            </Paper>
          </Grid>

          {/* Linha 2 - Cards de Navegação */}
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {/* Card - Cadastros Genéricos */}
              <Grid item xs={12} sm={6} md={6}>
                <Item onClick={() => NavigateTo("../cadastrogenerico")}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    p: 1
                  }}>
                    <BuildIcon
                      sx={{ 
                        color: colors.accent, 
                        fontSize: '2.5em',
                        mb: 1
                      }}
                    />
                    <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                      Cadastros
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                      Configurações gerais do sistema
                    </Typography>
                  </Box>
                </Item>
              </Grid>

              {/* Card - Formas de Pagamento */}
              <Grid item xs={12} sm={6} md={6}>
                <Item onClick={() => NavigateTo("../formasdepagamento")}>
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    p: 1
                  }}>
                    <PaidIcon
                      sx={{ 
                        color: colors.accent, 
                        fontSize: '2.5em',
                        mb: 1
                      }}
                    />
                    <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                      Formas de Pagamento
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                      Configuração de métodos de pagamento
                    </Typography>
                  </Box>
                </Item>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
